export default {
      id: "menu__maintenance-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "img/icons.svg#menu__maintenance",
      toString: function () {
        return this.url;
      }
    }